var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoFolderOpen = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_28983",
    "data-name": "Group 28983",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14.001,
    viewBox: "0 0 18 14.001",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47431",
    "data-name": "Path 47431",
    d: "M18.754,170.667H6a1.5,1.5,0,0,0-1.455,1.182l0,.008-2.2,7.687a.4.4,0,0,0,.012.255,1.5,1.5,0,0,0,1.391.978H16.5a1.5,1.5,0,0,0,1.439-1.128c0-.008.006-.017.009-.025L20.18,172.7a.394.394,0,0,0,.015-.068,1.562,1.562,0,0,0,.059-.413A1.53,1.53,0,0,0,18.754,170.667Z",
    transform: "translate(-2.254 -166.777)",
    fill: "#999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47432",
    "data-name": "Path 47432",
    d: "M.321,72.072a.331.331,0,0,0,.054,0A.377.377,0,0,0,.735,71.8l.836-2.927,0-.013A2.263,2.263,0,0,1,3.75,67.111H15.306a.371.371,0,0,0,.307-.165.749.749,0,0,0,.063-.49,1.506,1.506,0,0,0-1.41-1.036H8.8L7.4,64.114A.368.368,0,0,0,7.133,64H1.5A1.53,1.53,0,0,0,0,65.556v6.131A.385.385,0,0,0,.321,72.072Z",
    transform: "translate(0 -64)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoFolderOpen);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_folderOpen.82afef700c46aeb72b527e1f6fd4187f.svg";